import React from 'react';
import { Link } from 'react-router-dom';

const S = {
  footer: {
    background: '#1a1d24',
    borderTop: '1px solid #2a2d35',
    padding: '24px 16px',
    textAlign: 'center',
  },
  logo: {
    fontSize: '22px',
    fontWeight: 900,
    color: '#ffffff',
    marginBottom: '12px',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    gap: '24px',
    marginBottom: '16px',
  },
  link: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: 500,
    transition: 'color 0.15s',
  },
  copyright: {
    color: '#4b5563',
    fontSize: '12px',
  },
};

export default function Footer() {
  return (
    <footer style={S.footer}>
      <div style={S.logo}>BETONMINES</div>
      <div style={S.links}>
        <Link to="/tos" style={S.link}>Terms of Service</Link>
      </div>
      <div style={S.copyright}>© 2026 BetonMines. All rights reserved.</div>
    </footer>
  );
}
